/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LearningOutcomeReportRowDTO
 */
export interface LearningOutcomeReportRowDTO {
    /**
     *
     * @type {number}
     * @memberof LearningOutcomeReportRowDTO
     */
    orderNumber?: number;
    /**
     *
     * @type {string}
     * @memberof LearningOutcomeReportRowDTO
     */
    outcomeType?: string | null;
    /**
     *
     * @type {string}
     * @memberof LearningOutcomeReportRowDTO
     */
    description?: string | null;
    /**
     *
     * @type {string}
     * @memberof LearningOutcomeReportRowDTO
     */
    identificator?: string | null;
}

export function LearningOutcomeReportRowDTOFromJSON(json: any): LearningOutcomeReportRowDTO {
    return LearningOutcomeReportRowDTOFromJSONTyped(json, false);
}

export function LearningOutcomeReportRowDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningOutcomeReportRowDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'outcomeType': !exists(json, 'outcomeType') ? undefined : json['outcomeType'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
    };
}

export function LearningOutcomeReportRowDTOToJSON(value?: LearningOutcomeReportRowDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'orderNumber': value.orderNumber,
        'outcomeType': value.outcomeType,
        'description': value.description,
        'identificator': value.identificator,
    };
}

